import {
  PENDING_PRACTITIONER_RECEIVED,
  PRACTITIONER_LIST_RECEIVED,
  PRACTITIONER_SEARCH_LIST_RECEIVED,
  PRACTITIONER_LIST_RECEIVED_FOR_ADMIN,
} from "../constants/types/practitionerType";

const initialState = {
  pendingPractitionerList: [],
  practitionerList: [],
  searchPractitionerList: [],
  practitionerListForAdmin: [],
};

export const practitionerReducer = (state = initialState, action) => {
  switch (action.type) {
    case PENDING_PRACTITIONER_RECEIVED: {
      return {
        ...state,
        pendingPractitionerList: action.payload,
      };
    }
    case PRACTITIONER_LIST_RECEIVED: {
      return {
        ...state,
        practitionerList: action.payload,
      };
    }
    case PRACTITIONER_LIST_RECEIVED_FOR_ADMIN: {
      return {
        ...state,
        practitionerListForAdmin: action.payload,
      };
    }
    case PRACTITIONER_SEARCH_LIST_RECEIVED: {
      return {
        ...state,
        searchPractitionerList: action?.payload.map((item, index) => ({
          ...item,
          uniqueId: index,
        })),
      };
    }
    default:
      return state;
  }
};
